const DICT = {
  en: {
    langName: "English",
    language: "Language",
    noQuestions: "No questions loaded.",
    loadDemoQuiz: "Loaded demo quiz with 30 questions.",
    generatingWithGemini: (n, name) =>
      `Found ${n} slides in ${name}. Generating quiz questions with LLM…`,
    appTitle: "iQuiz",
    tagline:
      "A smart, lightweight web app for reviewing study materials and generating quizzes",
    help: "Help",
    close: "Close",
    uploadTitle:
      "Upload Lecture Slides or Notes in PDF to Generate a Quiz with A.I.",
    modelLabel: "Model:",
    targetCountLabel: "Target number of questions:",
    targetTooltip: "Limit the number of questions to generate (optional)",
    uploadPdfButton: "⬆️ Upload PDF File",
    loadTitle: "Download/Load Questions in JSON",
    downloadBtn: "⬇️ Download Questions",
    downloadTitle: "Download all questions as JSON",
    loadBtn: "📂 Load Questions",
    tagLabel: "Tag:",
    flaggedOnly: "Flagged only",
    modeLabel: "Mode:",
    modeQuiz: "MCQ",
    modeShort: "Short Answer",
    modeFlash: "Flashcard",
    retry: "Retry",
    clear: "Clear",
    confirmClearTitle: "Clear all questions and start fresh?",
    cancel: "Cancel",
    confirm: "Confirm",
    failedLoadDemo: "Failed to load demo quiz.",
    nothingToDownload: "Nothing to download — no questions loaded.",
    downloadedSuccess: (n, name) =>
      `Downloaded ${n} questions in ${name} successfully.`,
    extractingPdf: "Extracting slides from PDF…",
    noSlidesExtracted:
      "No slides extracted (expected an array of slide texts).",
    noTextFound: "No extractable text found in the PDF/slides.",
    generatedNoStream: (n) =>
      `Generated ${n} questions (fallback, no streaming).`,
    doneReceived: (n, base) => `Done! Received ${n} questions for ${base}.`,
    streamError: "Stream error.",
    failedPrefix: (msg) => `Failed: ${msg}`,
    loadedFromFile: (n, base) => `Loaded ${n} questions from ${base}.`,
    next: "Next",
    previous: "Previous",
    flag: "Flag",
    flagged: "Flagged",
    Question: "Question",
  },
  zh: {
    langName: "中文",
    language: "语言",
    noQuestions: "尚未加载题目。",
    loadDemoQuiz: "加载了包含 30 个问题的演示测验。",
    generatingWithGemini: (n, name) =>
      `在${name}中共检测到 ${n} 张幻灯片，正在用 LLM 生成测验题目…`,
    appTitle: "iQuiz",
    tagline: "用于复习与生成测验题目的轻量智能网页应用",
    help: "帮助",
    close: "关闭",
    uploadTitle: "上传课件或笔记（PDF），用 A.I. 生成测验题目",
    modelLabel: "模型：",
    targetCountLabel: "目标题目数量：",
    targetTooltip: "限制要生成的题目数量（可选）",
    uploadPdfButton: "⬆️ 上传 PDF 文件",
    loadTitle: "下载/加载题库（JSON）",
    downloadBtn: "⬇️ 下载题库",
    downloadTitle: "将所有题目下载为 JSON",
    loadBtn: "📂 加载题库",
    tagLabel: "标签：",
    flaggedOnly: "仅标记",
    modeLabel: "模式：",
    modeQuiz: "选择题",
    modeShort: "简答题",
    modeFlash: "抽认卡",
    retry: "重做",
    clear: "清空",
    confirmClearTitle: "清空所有题目并重新开始？",
    cancel: "取消",
    confirm: "确认",
    failedLoadDemo: "加载演示测验失败。",
    nothingToDownload: "没有可下载的内容——尚未加载题目。",
    downloadedSuccess: (n, name) => `已成功下载 ${n} 道题目（文件：${name}）。`,
    extractingPdf: "正在从 PDF 提取文本…",
    noSlidesExtracted: "未提取到幻灯片文本（需要字符串数组）。",
    noTextFound: "在 PDF/幻灯片中未找到可提取的文本。",
    generatedNoStream: (n) => `已生成 ${n} 道题目（后备模式，无流式）。`,
    doneReceived: (n, base) => `完成！已接收 ${n} 道题目（${base}）。`,
    streamError: "流式错误。",
    failedPrefix: (msg) => `失败：${msg}`,
    loadedFromFile: (n, base) => `已从 ${base} 加载 ${n} 道题目。`,
    next: "下一个",
    previous: "上一个",
    flag: "标记",
    flagged: "已标记",
    Question: "题目",
  },
  es: {
    langName: "Español",
    language: "Idioma",
    noQuestions: "No se han cargado preguntas.",
    loadDemoQuiz: "Cuestionario de demostración cargado con 30 preguntas.",
    generatingWithGemini: (n, name) =>
      `Se encontraron ${n} diapositivas en ${name}. Generando preguntas con LLM…`,
    appTitle: "iQuiz",
    tagline:
      "Una aplicación web inteligente y ligera para repasar materiales y generar cuestionarios",
    help: "Ayuda",
    close: "Cerrar",
    uploadTitle:
      "Sube diapositivas o notas en PDF para generar un cuestionario con A.I.",
    modelLabel: "Modelo:",
    targetCountLabel: "Número objetivo de preguntas:",
    targetTooltip: "Limita el número de preguntas a generar (opcional)",
    uploadPdfButton: "⬆️ Subir archivo PDF",
    loadTitle: "Descargar/Cargar preguntas en JSON",
    downloadBtn: "⬇️ Descargar preguntas",
    downloadTitle: "Descarga todas las preguntas como JSON",
    loadBtn: "📂 Cargar preguntas",
    tagLabel: "Etiqueta:",
    flaggedOnly: "Solo marcadas",
    modeLabel: "Modo:",
    modeQuiz: "Opción múltiple",
    modeShort: "Respuesta corta",
    modeFlash: "Tarjeta de memoria",
    retry: "Reintentar",
    clear: "Limpiar",
    confirmClearTitle: "¿Borrar todas las preguntas y empezar de nuevo?",
    cancel: "Cancelar",
    confirm: "Confirmar",
    failedLoadDemo: "No se pudo cargar el cuestionario de demostración.",
    nothingToDownload: "Nada que descargar — no hay preguntas cargadas.",
    downloadedSuccess: (n, name) =>
      `Se descargaron ${n} preguntas en ${name} correctamente.`,
    extractingPdf: "Extrayendo diapositivas del PDF…",
    noSlidesExtracted:
      "No se extrajeron diapositivas (se esperaba una matriz de textos).",
    noTextFound: "No se encontró texto extraíble en el PDF/diapositivas.",
    generatedNoStream: (n) =>
      `Se generaron ${n} preguntas (modo de respaldo, sin transmisión).`,
    doneReceived: (n, base) =>
      `¡Listo! Se recibieron ${n} preguntas para ${base}.`,
    streamError: "Error de transmisión.",
    failedPrefix: (msg) => `Error: ${msg}`,
    loadedFromFile: (n, base) => `Se cargaron ${n} preguntas desde ${base}.`,
    next: "Siguiente",
    previous: "Anterior",
    flag: "Marcar",
    flagged: "Marcado",
    Question: "Pregunta",
  },
  ar: {
    langName: "العربية",
    language: "اللغة",
    noQuestions: "لم يتم تحميل أي أسئلة.",
    loadDemoQuiz: "تم تحميل اختبار تجريبي يحتوي على 30 سؤالًا.",
    generatingWithGemini: (n, name) =>
      `تم العثور على ${n} شريحة في ${name}. جارٍ إنشاء الأسئلة باستخدام LLM…`,
    appTitle: "آي كويز",
    tagline: "تطبيق ويب ذكي وخفيف للمراجعة وإنشاء الاختبارات",
    help: "مساعدة",
    close: "إغلاق",
    uploadTitle:
      "قم برفع الشرائح أو الملاحظات بصيغة PDF لإنشاء اختبار باستخدام الذكاء الاصطناعي",
    modelLabel: "النموذج:",
    targetCountLabel: "عدد الأسئلة المستهدف:",
    targetTooltip: "حدد عدد الأسئلة المراد إنشاؤها (اختياري)",
    uploadPdfButton: "⬆️ رفع ملف PDF",
    loadTitle: "تحميل / تنزيل الأسئلة بصيغة JSON",
    downloadBtn: "⬇️ تنزيل الأسئلة",
    downloadTitle: "تنزيل جميع الأسئلة بصيغة JSON",
    loadBtn: "📂 تحميل الأسئلة",
    tagLabel: "الوسم:",
    flaggedOnly: "المعلَّمة فقط",
    modeLabel: "الوضع:",
    modeQuiz: "اختيار من متعدد",
    modeShort: "إجابة قصيرة",
    modeFlash: "بطاقة تعليمية",
    retry: "إعادة المحاولة",
    clear: "مسح",
    confirmClearTitle: "هل تريد مسح جميع الأسئلة والبدء من جديد؟",
    cancel: "إلغاء",
    confirm: "تأكيد",
    failedLoadDemo: "فشل تحميل الاختبار التجريبي.",
    nothingToDownload: "لا يوجد ما يمكن تنزيله — لم يتم تحميل أي أسئلة.",
    downloadedSuccess: (n, name) => `تم تنزيل ${n} سؤالًا في ${name} بنجاح.`,
    extractingPdf: "جارٍ استخراج الشرائح من ملف PDF…",
    noSlidesExtracted: "لم يتم استخراج أي شرائح (تم توقع مصفوفة نصوص).",
    noTextFound: "لم يتم العثور على نص قابل للاستخراج في ملف PDF.",
    generatedNoStream: (n) =>
      `تم إنشاء ${n} سؤالًا (وضع احتياطي بدون بث مباشر).`,
    doneReceived: (n, base) => `تم! تم استلام ${n} سؤالًا من ${base}.`,
    streamError: "خطأ في البث.",
    failedPrefix: (msg) => `فشل: ${msg}`,
    loadedFromFile: (n, base) => `تم تحميل ${n} سؤالًا من ${base}.`,
    next: "التالي",
    previous: "السابق",
    flag: "تمييز",
    flagged: "مميز",
    Question: "سؤال",
  },
  fr: {
    langName: "Français",
    language: "Langue",
    noQuestions: "Aucune question chargée.",
    loadDemoQuiz: "Quiz de démonstration chargé avec 30 questions.",
    generatingWithGemini: (n, name) =>
      `Trouvé ${n} diapositives dans ${name}. Génération de questions avec LLM…`,
    appTitle: "iQuiz",
    tagline:
      "Une application web intelligente et légère pour réviser et générer des quiz",
    help: "Aide",
    close: "Fermer",
    uploadTitle:
      "Téléchargez des diapositives ou des notes en PDF pour générer un quiz avec l'A.I.",
    modelLabel: "Modèle :",
    targetCountLabel: "Nombre cible de questions :",
    targetTooltip: "Limitez le nombre de questions à générer (optionnel)",
    uploadPdfButton: "⬆️ Télécharger le fichier PDF",
    loadTitle: "Télécharger/Charger les questions en JSON",
    downloadBtn: "⬇️ Télécharger les questions",
    downloadTitle: "Téléchargez toutes les questions au format JSON",
    loadBtn: "📂 Charger les questions",
    tagLabel: "Étiquette :",
    flaggedOnly: "Uniquement marquées",
    modeLabel: "Mode :",
    modeQuiz: "QCM",
    modeShort: "Réponse courte",
    modeFlash: "Carte mémoire",
    retry: "Réessayer",
    clear: "Effacer",
    confirmClearTitle: "Effacer toutes les questions et recommencer ?",
    cancel: "Annuler",
    confirm: "Confirmer",
    failedLoadDemo: "Échec du chargement du quiz de démonstration.",
    nothingToDownload: "Rien à télécharger — aucune question chargée.",
    downloadedSuccess: (n, name) =>
      `Téléchargé ${n} questions dans ${name} avec succès.`,
    extractingPdf: "Extraction des diapositives du PDF…",
    noSlidesExtracted:
      "Aucune diapositive extraite (une liste de textes était attendue).",
    noTextFound: "Aucun texte extractible trouvé dans le PDF/diapositives.",
    generatedNoStream: (n) =>
      `Généré ${n} questions (mode de secours, sans streaming).`,
    doneReceived: (n, base) => `Terminé ! Reçu ${n} questions pour ${base}.`,
    streamError: "Erreur de flux.",
    failedPrefix: (msg) => `Échec : ${msg}`,
    loadedFromFile: (n, base) => `Chargé ${n} questions depuis ${base}.`,
    next: "Suivant",
    previous: "Précédent",
    flag: "Marquer",
    flagged: "Marqué",
    Question: "Question",
  },

  ja: {
    langName: "日本語",
    language: "言語",
    noQuestions: "質問が読み込まれていません。",
    loadDemoQuiz: "デモクイズ（30問）を読み込みました。",
    generatingWithGemini: (n, name) =>
      `${name} で ${n} 枚のスライドが見つかりました。LLMでクイズ問題を生成しています…`,
    appTitle: "iQuiz",
    tagline:
      "学習資料を復習し、クイズを生成するためのスマートで軽量なWebアプリ",
    help: "ヘルプ",
    close: "閉じる",
    uploadTitle:
      "PDF形式の講義スライドやノートをアップロードしてAIでクイズを生成",
    modelLabel: "モデル：",
    targetCountLabel: "生成する問題数：",
    targetTooltip: "生成する問題の数を制限します（任意）",
    uploadPdfButton: "⬆️ PDFファイルをアップロード",
    loadTitle: "JSON形式で質問をダウンロード／読み込み",
    downloadBtn: "⬇️ 質問をダウンロード",
    downloadTitle: "すべての質問をJSONとしてダウンロード",
    loadBtn: "📂 質問を読み込み",
    tagLabel: "タグ：",
    flaggedOnly: "フラグ付きのみ",
    modeLabel: "モード：",
    modeQuiz: "選択問題",
    modeShort: "短答問題",
    modeFlash: "フラッシュカード",
    retry: "再試行",
    clear: "クリア",
    confirmClearTitle: "すべての質問を消去して最初からやり直しますか？",
    cancel: "キャンセル",
    confirm: "確認",
    failedLoadDemo: "デモクイズの読み込みに失敗しました。",
    nothingToDownload: "ダウンロードできる質問がありません。",
    downloadedSuccess: (n, name) =>
      `${name} に ${n} 問の質問を正常にダウンロードしました。`,
    extractingPdf: "PDFからスライドを抽出しています…",
    noSlidesExtracted:
      "スライドが抽出されませんでした（文字列の配列が必要です）。",
    noTextFound: "PDF/スライド内に抽出可能なテキストが見つかりませんでした。",
    generatedNoStream: (n) =>
      `${n} 問を生成しました（フォールバックモード、ストリームなし）。`,
    doneReceived: (n, base) => `完了！${base} から ${n} 問を受信しました。`,
    streamError: "ストリームエラー。",
    failedPrefix: (msg) => `失敗：${msg}`,
    loadedFromFile: (n, base) => `${base} から ${n} 問の質問を読み込みました。`,
    next: "次へ",
    previous: "前へ",
    flag: "フラグ",
    flagged: "フラグ済み",
    Question: "質問",
  },
  de: {
    langName: "Deutsch",
    language: "Sprache",
    noQuestions: "Keine Fragen geladen.",
    loadDemoQuiz: "Demo-Quiz mit 30 Fragen geladen.",
    generatingWithGemini: (n, name) =>
      `${n} Folien in ${name} gefunden. Erzeuge Quizfragen mit LLM…`,
    appTitle: "iQuiz",
    tagline:
      "Eine intelligente, leichte Web-App zum Wiederholen und Erstellen von Quizfragen",
    help: "Hilfe",
    close: "Schließen",
    uploadTitle:
      "Laden Sie PDF-Vorlesungsfolien oder Notizen hoch, um ein Quiz mit KI zu generieren.",
    modelLabel: "Modell:",
    targetCountLabel: "Zielanzahl der Fragen:",
    targetTooltip: "Begrenzt die Anzahl der zu generierenden Fragen (optional)",
    uploadPdfButton: "⬆️ PDF-Datei hochladen",
    loadTitle: "Fragen im JSON-Format herunterladen/laden",
    downloadBtn: "⬇️ Fragen herunterladen",
    downloadTitle: "Alle Fragen als JSON herunterladen",
    loadBtn: "📂 Fragen laden",
    tagLabel: "Tag:",
    flaggedOnly: "Nur markierte",
    modeLabel: "Modus:",
    modeQuiz: "Multiple Choice",
    modeShort: "Kurzantwort",
    modeFlash: "Lernkarte",
    retry: "Wiederholen",
    clear: "Löschen",
    confirmClearTitle: "Alle Fragen löschen und neu beginnen?",
    cancel: "Abbrechen",
    confirm: "Bestätigen",
    failedLoadDemo: "Demo-Quiz konnte nicht geladen werden.",
    nothingToDownload: "Nichts zum Herunterladen – keine Fragen geladen.",
    downloadedSuccess: (n, name) =>
      `${n} Fragen erfolgreich in ${name} heruntergeladen.`,
    extractingPdf: "Extrahiere Folien aus PDF…",
    noSlidesExtracted: "Keine Folien extrahiert (Array von Texten erwartet).",
    noTextFound: "Kein extrahierbarer Text in PDF/Folien gefunden.",
    generatedNoStream: (n) =>
      `${n} Fragen generiert (Fallback, kein Streaming).`,
    doneReceived: (n, base) => `Fertig! ${n} Fragen für ${base} erhalten.`,
    streamError: "Stream-Fehler.",
    failedPrefix: (msg) => `Fehler: ${msg}`,
    loadedFromFile: (n, base) => `${n} Fragen aus ${base} geladen.`,
    next: "Weiter",
    previous: "Zurück",
    flag: "Markieren",
    flagged: "Markiert",
    Question: "Frage",
  },
  ko: {
    langName: "한국어",
    language: "언어",
    noQuestions: "불러온 문제가 없습니다.",
    loadDemoQuiz: "30개의 문제로 구성된 데모 퀴즈를 불러왔습니다.",
    generatingWithGemini: (n, name) =>
      `${name}에서 ${n}개의 슬라이드를 발견했습니다. LLM로 퀴즈 문제를 생성 중…`,
    appTitle: "iQuiz",
    tagline: "학습 자료 복습과 퀴즈 생성을 위한 스마트하고 가벼운 웹 앱",
    help: "도움말",
    close: "닫기",
    uploadTitle: "PDF 형식의 강의 노트나 슬라이드를 업로드하여 AI로 퀴즈 생성",
    modelLabel: "모델:",
    targetCountLabel: "생성할 문제 수:",
    targetTooltip: "생성할 문제 수를 제한합니다 (선택 사항)",
    uploadPdfButton: "⬆️ PDF 파일 업로드",
    loadTitle: "JSON 형식으로 문제 다운로드/불러오기",
    downloadBtn: "⬇️ 문제 다운로드",
    downloadTitle: "모든 문제를 JSON으로 다운로드",
    loadBtn: "📂 문제 불러오기",
    tagLabel: "태그:",
    flaggedOnly: "표시된 문제만",
    modeLabel: "모드:",
    modeQuiz: "객관식",
    modeShort: "단답형",
    modeFlash: "플래시카드",
    retry: "다시 시도",
    clear: "지우기",
    confirmClearTitle: "모든 문제를 삭제하고 새로 시작하시겠습니까?",
    cancel: "취소",
    confirm: "확인",
    failedLoadDemo: "데모 퀴즈를 불러오지 못했습니다.",
    nothingToDownload: "다운로드할 문제가 없습니다.",
    downloadedSuccess: (n, name) =>
      `${name} 파일에 ${n}개의 문제를 성공적으로 다운로드했습니다.`,
    extractingPdf: "PDF에서 슬라이드 추출 중…",
    noSlidesExtracted: "슬라이드가 추출되지 않았습니다 (문자열 배열이 필요함).",
    noTextFound: "PDF/슬라이드에서 추출할 수 있는 텍스트를 찾을 수 없습니다.",
    generatedNoStream: (n) =>
      `${n}개의 문제를 생성했습니다 (대체 모드, 스트리밍 없음).`,
    doneReceived: (n, base) => `완료! ${base}에서 ${n}개의 문제를 받았습니다.`,
    streamError: "스트리밍 오류.",
    failedPrefix: (msg) => `실패: ${msg}`,
    loadedFromFile: (n, base) => `${base}에서 ${n}개의 문제를 불러왔습니다.`,
    next: "다음",
    previous: "이전",
    flag: "표시",
    flagged: "표시됨",
    Question: "문제",
  },
  hi: {
    langName: "हिन्दी",
    language: "भाषा",
    noQuestions: "कोई प्रश्न लोड नहीं किया गया है।",
    loadDemoQuiz: "30 प्रश्नों वाला डेमो क्विज़ लोड किया गया।",
    generatingWithGemini: (n, name) =>
      `${name} में ${n} स्लाइडें मिलीं। LLM के साथ क्विज़ प्रश्न बना रहा है…`,
    appTitle: "iQuiz",
    tagline:
      "अध्ययन सामग्री की समीक्षा और क्विज़ बनाने के लिए एक स्मार्ट, हल्का वेब ऐप",
    help: "सहायता",
    close: "बंद करें",
    uploadTitle:
      "PDF में लेक्चर स्लाइड्स या नोट्स अपलोड करें और AI से क्विज़ जनरेट करें",
    modelLabel: "मॉडल:",
    targetCountLabel: "लक्ष्य प्रश्नों की संख्या:",
    targetTooltip: "जनरेट करने वाले प्रश्नों की संख्या सीमित करें (वैकल्पिक)",
    uploadPdfButton: "⬆️ PDF फ़ाइल अपलोड करें",
    loadTitle: "JSON में प्रश्न डाउनलोड/लोड करें",
    downloadBtn: "⬇️ प्रश्न डाउनलोड करें",
    downloadTitle: "सभी प्रश्नों को JSON के रूप में डाउनलोड करें",
    loadBtn: "📂 प्रश्न लोड करें",
    tagLabel: "टैग:",
    flaggedOnly: "केवल चिह्नित",
    modeLabel: "मोड:",
    modeQuiz: "बहुविकल्पीय",
    modeShort: "संक्षिप्त उत्तर",
    modeFlash: "फ्लैशकार्ड",
    retry: "फिर से प्रयास करें",
    clear: "साफ करें",
    confirmClearTitle: "सभी प्रश्नों को हटाकर दोबारा शुरू करें?",
    cancel: "रद्द करें",
    confirm: "पुष्टि करें",
    failedLoadDemo: "डेमो क्विज़ लोड करने में विफल।",
    nothingToDownload:
      "डाउनलोड करने के लिए कुछ भी नहीं — कोई प्रश्न लोड नहीं किया गया।",
    downloadedSuccess: (n, name) =>
      `${name} में ${n} प्रश्न सफलतापूर्वक डाउनलोड किए गए।`,
    extractingPdf: "PDF से स्लाइड्स निकाल रहा है…",
    noSlidesExtracted:
      "कोई स्लाइड्स नहीं निकाली गईं (टेक्स्ट स्ट्रिंग्स की सूची अपेक्षित थी)।",
    noTextFound: "PDF/स्लाइड्स में कोई पाठ नहीं मिला जिसे निकाला जा सके।",
    generatedNoStream: (n) =>
      `${n} प्रश्न बनाए गए (फॉलबैक मोड, बिना स्ट्रीमिंग)।`,
    doneReceived: (n, base) => `समाप्त! ${base} से ${n} प्रश्न प्राप्त हुए।`,
    streamError: "स्ट्रीम त्रुटि।",
    failedPrefix: (msg) => `विफल: ${msg}`,
    loadedFromFile: (n, base) => `${base} से ${n} प्रश्न लोड किए गए।`,
    next: "अगला",
    previous: "पिछला",
    flag: "चिह्नित करें",
    flagged: "चिह्नित",
    Question: "प्रश्न",
  },
  ru: {
    langName: "Русский",
    language: "Язык",
    noQuestions: "Вопросы не загружены.",
    loadDemoQuiz: "Загружена демонстрационная викторина с 30 вопросами.",
    generatingWithGemini: (n, name) =>
      `В файле ${name} найдено ${n} слайдов. Генерация вопросов с помощью LLM…`,
    appTitle: "iQuiz",
    tagline:
      "Умное и лёгкое веб-приложение для повторения материала и создания викторин",
    help: "Помощь",
    close: "Закрыть",
    uploadTitle:
      "Загрузите слайды или заметки в формате PDF, чтобы создать викторину с помощью ИИ",
    modelLabel: "Модель:",
    targetCountLabel: "Целевое количество вопросов:",
    targetTooltip: "Ограничить количество создаваемых вопросов (необязательно)",
    uploadPdfButton: "⬆️ Загрузить PDF-файл",
    loadTitle: "Загрузить/скачать вопросы в формате JSON",
    downloadBtn: "⬇️ Скачать вопросы",
    downloadTitle: "Скачать все вопросы в формате JSON",
    loadBtn: "📂 Загрузить вопросы",
    tagLabel: "Тег:",
    flaggedOnly: "Только отмеченные",
    modeLabel: "Режим:",
    modeQuiz: "Тест",
    modeShort: "Короткий ответ",
    modeFlash: "Карточки",
    retry: "Повторить",
    clear: "Очистить",
    confirmClearTitle: "Очистить все вопросы и начать заново?",
    cancel: "Отмена",
    confirm: "Подтвердить",
    failedLoadDemo: "Не удалось загрузить демонстрационную викторину.",
    nothingToDownload: "Нечего скачивать — вопросы не загружены.",
    downloadedSuccess: (n, name) =>
      `Успешно скачано ${n} вопросов в файл ${name}.`,
    extractingPdf: "Извлечение слайдов из PDF…",
    noSlidesExtracted: "Слайды не извлечены (ожидался массив строк).",
    noTextFound: "Не найден извлекаемый текст в PDF/слайдах.",
    generatedNoStream: (n) =>
      `Сгенерировано ${n} вопросов (резервный режим, без потока).`,
    doneReceived: (n, base) => `Готово! Получено ${n} вопросов из ${base}.`,
    streamError: "Ошибка потока.",
    failedPrefix: (msg) => `Ошибка: ${msg}`,
    loadedFromFile: (n, base) => `Загружено ${n} вопросов из ${base}.`,
    next: "Далее",
    previous: "Назад",
    flag: "Отметить",
    flagged: "Отмечено",
    Question: "Вопрос",
  },
  pt: {
    langName: "Português",
    language: "Idioma",
    noQuestions: "Nenhuma pergunta carregada.",
    loadDemoQuiz: "Questionário de demonstração carregado com 30 perguntas.",
    generatingWithGemini: (n, name) =>
      `${n} slides encontrados em ${name}. Gerando perguntas com o LLM…`,
    appTitle: "iQuiz",
    tagline:
      "Um aplicativo web inteligente e leve para revisar materiais e gerar questionários",
    help: "Ajuda",
    close: "Fechar",
    uploadTitle:
      "Envie slides ou anotações em PDF para gerar um questionário com A.I.",
    modelLabel: "Modelo:",
    targetCountLabel: "Número alvo de perguntas:",
    targetTooltip: "Limite o número de perguntas a gerar (opcional)",
    uploadPdfButton: "⬆️ Enviar arquivo PDF",
    loadTitle: "Baixar/Carregar perguntas em JSON",
    downloadBtn: "⬇️ Baixar perguntas",
    downloadTitle: "Baixe todas as perguntas em formato JSON",
    loadBtn: "📂 Carregar perguntas",
    tagLabel: "Etiqueta:",
    flaggedOnly: "Somente marcadas",
    modeLabel: "Modo:",
    modeQuiz: "Múltipla escolha",
    modeShort: "Resposta curta",
    modeFlash: "Flashcard",
    retry: "Repetir",
    clear: "Limpar",
    confirmClearTitle: "Limpar todas as perguntas e começar novamente?",
    cancel: "Cancelar",
    confirm: "Confirmar",
    failedLoadDemo: "Falha ao carregar o questionário de demonstração.",
    nothingToDownload: "Nada para baixar — nenhuma pergunta carregada.",
    downloadedSuccess: (n, name) =>
      `${n} perguntas baixadas com sucesso em ${name}.`,
    extractingPdf: "Extraindo slides do PDF…",
    noSlidesExtracted:
      "Nenhum slide extraído (era esperado um array de textos).",
    noTextFound: "Nenhum texto extraível encontrado no PDF/slides.",
    generatedNoStream: (n) =>
      `${n} perguntas geradas (modo de reserva, sem streaming).`,
    doneReceived: (n, base) =>
      `Concluído! Recebidas ${n} perguntas de ${base}.`,
    streamError: "Erro de streaming.",
    failedPrefix: (msg) => `Falhou: ${msg}`,
    loadedFromFile: (n, base) => `${n} perguntas carregadas de ${base}.`,
    next: "Próximo",
    previous: "Anterior",
    flag: "Marcar",
    flagged: "Marcada",
    Question: "Pergunta",
  },
  it: {
    langName: "Italiano",
    language: "Lingua",
    noQuestions: "Nessuna domanda caricata.",
    loadDemoQuiz: "Quiz dimostrativo caricato con 30 domande.",
    generatingWithGemini: (n, name) =>
      `Trovate ${n} diapositive in ${name}. Generazione delle domande del quiz con LLM…`,
    appTitle: "iQuiz",
    tagline:
      "Un'app web intelligente e leggera per rivedere materiali e generare quiz",
    help: "Aiuto",
    close: "Chiudi",
    uploadTitle:
      "Carica diapositive o appunti in PDF per generare un quiz con l'IA",
    modelLabel: "Modello:",
    targetCountLabel: "Numero di domande target:",
    targetTooltip: "Limita il numero di domande da generare (opzionale)",
    uploadPdfButton: "⬆️ Carica file PDF",
    loadTitle: "Scarica/Carica domande in formato JSON",
    downloadBtn: "⬇️ Scarica domande",
    downloadTitle: "Scarica tutte le domande come file JSON",
    loadBtn: "📂 Carica domande",
    tagLabel: "Etichetta:",
    flaggedOnly: "Solo contrassegnate",
    modeLabel: "Modalità:",
    modeQuiz: "Scelta multipla",
    modeShort: "Risposta breve",
    modeFlash: "Flashcard",
    retry: "Riprova",
    clear: "Cancella",
    confirmClearTitle: "Cancellare tutte le domande e ricominciare?",
    cancel: "Annulla",
    confirm: "Conferma",
    failedLoadDemo: "Impossibile caricare il quiz dimostrativo.",
    nothingToDownload: "Niente da scaricare — nessuna domanda caricata.",
    downloadedSuccess: (n, name) =>
      `${n} domande scaricate con successo in ${name}.`,
    extractingPdf: "Estrazione delle diapositive dal PDF…",
    noSlidesExtracted:
      "Nessuna diapositiva estratta (era previsto un array di testi).",
    noTextFound: "Nessun testo estraibile trovato nel PDF o nelle diapositive.",
    generatedNoStream: (n) =>
      `${n} domande generate (modalità di riserva, senza streaming).`,
    doneReceived: (n, base) => `Completato! Ricevute ${n} domande da ${base}.`,
    streamError: "Errore di streaming.",
    failedPrefix: (msg) => `Errore: ${msg}`,
    loadedFromFile: (n, base) => `${n} domande caricate da ${base}.`,
    next: "Avanti",
    previous: "Indietro",
    flag: "Contrassegna",
    flagged: "Contrassegnata",
    Question: "Domanda",
  },
};
export default DICT;